// We need to reproduce mimics components and tokens here
// Old excel uses legacy edge browser internally and must be supported
// Mimics doesn't support es5 and crashes the add-in in legacy edge

export * as tokens from "./tokens";
export { default as Box } from "./Box";
export { default as Button } from "./Button";
